/**
 * @generated SignedSource<<0600ef97c628f8fc714a8c0629ead470>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VaultManagementGroupLabel_vaultManagementGroup$data = {
  readonly id: string;
  readonly managers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member">;
      } | null;
    }>;
  };
  readonly name: string;
  readonly " $fragmentType": "VaultManagementGroupLabel_vaultManagementGroup";
};
export type VaultManagementGroupLabel_vaultManagementGroup$key = {
  readonly " $data"?: VaultManagementGroupLabel_vaultManagementGroup$data;
  readonly " $fragmentSpreads": FragmentRefs<"VaultManagementGroupLabel_vaultManagementGroup">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VaultManagementGroupLabel_vaultManagementGroup",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MemberConnection",
      "kind": "LinkedField",
      "name": "managers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MemberEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Member",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "UserAvatar_member"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "VaultManagementGroup",
  "abstractKey": null
};
})();

(node as any).hash = "1c65f5e09a485161a02bed5929085755";

export default node;
